import { Button } from "primereact/button";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import localeText from "../../locale";
import { locale } from "../../utilities/locale/locale";

const NavDepartmentSearch = ({ categories, onSearch }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Menu data structure
  const categoriesSample = [
    { title: "Products", items: ["Smartphones", "Laptops", "Tablets", "Accessories", "Audio"] },
    {
      title: "Services",
      items: ["Repairs", "Support", "Training", "Consultation", "Installation"],
    },
    { title: "Resources", items: ["Tutorials", "Guides", "Downloads", "FAQs", "Videos"] },
    { title: "Company", items: ["About", "Team", "Careers", "Contact", "Locations"] },
  ];

  const topCategories = categories.slice(0, 4);

  const topCategoriesSample = [
    {
      descriptionEnglish: "Agro and Industry",
      descriptionSpanish: "Agro y Industria",
      descriptionItalian: "Agro e Industria",
      descriptionPortuguese: "Agro e Industria",
      id: 11,
    },
    {
      descriptionEnglish: "pets",
      descriptionSpanish: "Animales de estimación",
      descriptionItalian: "Animali domestici",
      descriptionPortuguese: "Animais de estimação",
      id: 10,
    },
    {
      descriptionEnglish: "Children items",
      descriptionSpanish: "Artículos para niños",
      descriptionItalian: "Articoli per bambini",
      descriptionPortuguese: "Artigos infantis",
      id: 9,
    },
    {
      descriptionEnglish: "Auto and parts",
      descriptionSpanish: "Auto e piezas",
      descriptionItalian: "Auto e ricambi",
      descriptionPortuguese: "Autos e peças",
      id: 1,
    },
    {
      descriptionEnglish: localeText("fringeBenefits"),
      descriptionSpanish: localeText("fringeBenefits"),
      descriptionItalian: localeText("fringeBenefits"),
      descriptionPortuguese: localeText("fringeBenefits"),
      id: -1,
    },
  ];

  const handleCategoryName = (category) => {
    const descriptions = {
      en: category.descriptionEnglish,
      it: category.descriptionItalian,
      pt: category.descriptionPortuguese,
      es: category.descriptionSpanish,
    };
    return descriptions[locale] ?? "";
  };

  const handleCategorySearch = (category) => {
    if (category.id === -1) {
      window.location.href = "/fringe-benefits?search=ALL&currency=ALL&area=ALL";
      return;
    }

    onSearch("ALL", category);
  };

  return (
    <nav className="no-shadow px-4 py-1 hidden md:block" style={{ backgroundColor: "#3CA358" }}>
      {/* Menu Items */}
      <div className="flex gap-4 align-items-center text-sm">
        {/* Mega Menu Trigger */}
        <div className="relative h-full" ref={menuRef}>
          <Link
            /* onClick={() => setIsOpen(!isOpen)} */
            to="/categories"
            className="flex items-center bg-transparent border-none p-no-outline p-2 text-sm font-bold text-white"
          >
            <i className="pi pi-bars mr-2"></i> {localeText("allDepartments")}
          </Link>

          {/* Mega Menu Dropdown */}
          {isOpen && (
            <div className="absolute left-0 w-screen max-w-6xl bg-white shadow-lg p-6 z-2">
              <div className="grid grid-cols-4 gap-6">
                {categoriesSample.map((category, index) => (
                  <div key={index}>
                    <h3 className="font-medium mb-3">{category.title}</h3>
                    <ul className="space-y-2">
                      {category.items.map((item, i) => (
                        <li key={i}>
                          <a href="#" className="text-gray-600 hover:text-indigo-600">
                            {item}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Regular Links */}
        {/* <a href="#" className="flex items-center hover:white p-2" style={{ color: "#D9F7EC" }}>
          Eletrônicos e celulares
        </a>
        <a href="#" className="flex items-center hover:white p-2" style={{ color: "#D9F7EC" }}>
          Serviços
        </a>
        <a href="#" className="flex items-center hover:white p-2" style={{ color: "#D9F7EC" }}>
          Vestuário
        </a>
        <a href="#" className="flex items-center hover:white p-2" style={{ color: "#D9F7EC" }}>
          Saúde e bem estar
        </a> */}
        {topCategoriesSample.map((category) => (
          <Button
            link
            key={category.id}
            className="flex items-center hover:text-white hover:underline p-2 text-sm"
            style={{ color: "#D9F7EC" }}
            onClick={() => handleCategorySearch(category)}
          >
            {handleCategoryName(category)}
          </Button>
        ))}
        {/* <div className="flex  flex-row-reverse flex-grow-1">
          <Button
            link
            className="flex items-center text-white p-2 font-bold text-sm"
            onClick={() => {
              const element = document.getElementById("shop-sections");
              if (element) {
                element.scrollIntoView({ behavior: "smooth" });
              }
            }}
          >
            {localeText("bestOffers")}
          </Button>
        </div> */}
      </div>
    </nav>
  );
};

export default NavDepartmentSearch;
